import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useGeoTreeApi } from "../api/useGeoTreeApi";
import { useGlobalDispatch, useGlobalState } from "../data/global/hooks";
import { useClientRoutesAndLabels } from "../ui/routes";

const useHasGeoAccess = (client: string) => {
  const navigate = useNavigate();
  const routes = useClientRoutesAndLabels(client);

  //Check users geo access
  const { hasGeoAccess } = useGlobalState();
  const { updateGeoAccess } = useGlobalDispatch();
  const { error } = useGeoTreeApi(client);
  if (error && error.statusText === "Forbidden" && hasGeoAccess) {
    updateGeoAccess(false);
  }

  useEffect(() => {
    if (!hasGeoAccess) {
      navigate(routes.noAccess.path);
    }
  }, [hasGeoAccess, navigate, routes.noAccess.path]);
};

export default useHasGeoAccess;
